import { render, staticRenderFns } from "./paymentSuccessPage.vue?vue&type=template&id=205046ca&scoped=true"
import script from "./paymentSuccessPage.vue?vue&type=script&lang=js"
export * from "./paymentSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./paymentSuccessPage.vue?vue&type=style&index=0&id=205046ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205046ca",
  null
  
)

export default component.exports